import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';


const firebaseConfig = {
    apiKey: "AIzaSyCG83pQqHgcbORoYLM1GGMjrC0DxaMgIIU",
    authDomain: "hustle-react-86c1f.firebaseapp.com",
    databaseURL: "https://hustle-react-86c1f.firebaseio.com",
    projectId: "hustle-react-86c1f",
    storageBucket: "hustle-react-86c1f.appspot.com",
    messagingSenderId: "370537571501",
    appId: "1:370537571501:web:3203a7696fc37689439224",
    measurementId: "G-6P02TWNV99"
};
// Initialize Firebase

class Firebase {
    constructor() {
        app.initializeApp(firebaseConfig);
        this.fieldValue = app.firestore.FieldValue;


        this.auth = app.auth();
        this.db = app.firestore();

    }

    // **** Auth ****

    doCreateUserWithEmailAndPassword = (email, password) =>
        this.auth.createUserWithEmailAndPassword(email, password);

    doSignInWithEmailAndPassword = (email, password) =>
        this.auth.signInWithEmailAndPassword(email, password);

    doSignOut = () => this.auth.signOut();

    doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

    doPasswordUpdate = password => this.auth.currentUser.updatePassword(password);

}
export default Firebase;